<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaEntradas"
      :camposTabela="retornaCamposTabela()"
      :camposMascaraData="['dataEntrada']"
      ordenarPor="codigo"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @limpar="limpar"
    />

  </div>
</template>

<script>
// import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import EstoqueService from '../../services/estoque.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroEntradas',
      icon: 'person_add',
      tooltip: 'Cadastrar Entradas',
    },
  ],
}

export default {
  name: 'Estoque',
  components: {
    LayoutTelaFiltros,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaEntradas: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  async created() {
    await this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const Entradas = await EstoqueService.retornaTodos(pagina)
        this.listaEntradas = Entradas.lista
        this.totalDePaginas = Entradas.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const Entradas = await EstoqueService.retornaTodosPorFiltro(filtro, pagina)
        this.listaEntradas = Entradas.lista
        this.totalDePaginas = Entradas.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-entradas-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaEntradas = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        'filial.codigo': {
          label: 'Filial',
        },
        'produto.codigo': {
          label: 'Código produto',
        },
        'produto.nome': {
          label: 'Nome produto',
        },
        quantidade: {
          label: 'Quantidade',
        },
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
